import * as firebase from "firebase/app";
import "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = firebase.initializeApp({
  apiKey: "AIzaSyBDC_3Lv1_G_vRgfVnJfeaWz6rNLklLTlM",
  authDomain: "tesla-45121.firebaseapp.com",
  databaseURL: "https://tesla-45121.firebaseio.com",
  projectId: "tesla-45121",
  storageBucket: "tesla-45121.appspot.com",
  messagingSenderId: "523587324766",
  appId: "1:523587324766:web:e0b886d0a21a64bdb85dcf",
  measurementId: "G-3N7FPCW1XC",
});
// Initialize Firebase

export default firebaseConfig;
